import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/import-jobs'

export const upload = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: data,
  })

  return response?.data
}

export const getJobDetail = async (jobId) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${jobId}`,
  })
  return response?.data
}